import {
  browserStorageReadItem,
  browserStorageWriteItem,
} from '../browser-storage'
import { type EXPERIMENT_VARIATION } from '../model/EXPERIMENT_VARIATION'

export const EXPERIMENTS_ACTIVATED_BROWSER_STORAGE_KEY = 'activatedExperiments'

export type ExperimentsActivatedBrowserStorageItem = {
  name: string
  variant: EXPERIMENT_VARIATION
}

export const experimentsActivatedBrowserStorageGet =
  (): ExperimentsActivatedBrowserStorageItem[] => {
    const activatedExperiments = browserStorageReadItem(
      'sessionStorage',
      EXPERIMENTS_ACTIVATED_BROWSER_STORAGE_KEY,
    )

    if (!activatedExperiments) {
      return []
    }

    try {
      return JSON.parse(
        activatedExperiments,
      ) as ExperimentsActivatedBrowserStorageItem[]
    } catch {
      return []
    }
  }

export const experimentsActivatedBrowserStorageAdd = (
  activatedExperiments: ExperimentsActivatedBrowserStorageItem[],
  experiments: ExperimentsActivatedBrowserStorageItem[],
): ExperimentsActivatedBrowserStorageItem[] => {
  const activatedExperimentsMap = new Map(
    activatedExperiments.map((experiment) => [experiment.name, experiment]),
  )

  for (const experiment of experiments) {
    activatedExperimentsMap.set(experiment.name, experiment)
  }

  return activatedExperimentsMap.values().toArray()
}

export const experimentsActivatedBrowserStorageStore = (
  experiments: ExperimentsActivatedBrowserStorageItem[],
): void => {
  const activatedExperiments = experimentsActivatedBrowserStorageAdd(
    experimentsActivatedBrowserStorageGet(),
    experiments,
  )

  browserStorageWriteItem(
    'sessionStorage',
    EXPERIMENTS_ACTIVATED_BROWSER_STORAGE_KEY,
    JSON.stringify(activatedExperiments),
  )
}
